import React from 'react'

export const InvoiceTableHeader: React.FunctionComponent = () => (
  <>
    <colgroup>
      <col style={{ width: '20%' }} />
      <col style={{ width: '25%' }} />
      <col style={{ width: '15%' }} />
      <col style={{ width: '15%' }} />
      <col style={{ width: '25%' }} />
    </colgroup>
    <thead>
      <tr>
        <th>Invoice No.</th>
        <th>Period</th>
        <th>Amount</th>
        <th>Status</th>
        <th>Actions</th>
      </tr>
    </thead>
  </>
)
